import { useNavigate } from "react-router-dom";
import "./style.css";
import React, { Fragment, useEffect, useState } from "react";
import Header from "../../layout/header";
import { Button, Card, Col, Container, Image, Row, Spinner } from "react-bootstrap";
import { CardBody, CardHeader } from "reactstrap";
import { loadFromLocalStorage, saveToLocalStorage } from "../../utils/LocalStorageUtils";
import { apiCall, failedMessage, successMessage } from "../../utils/httpClient";
import apiEndPoint from "../../utils/apiEndPoint";
import { isEmpty } from "utils/utils";


function AccountSetting() {
    const navigate = useNavigate();
    const [userData, setUserData] = useState({});
    const [profileImage, setProfileImage] = useState(null);
    const [isLoading, setLoading] = useState(false);
    useEffect(() => {
        const authData = loadFromLocalStorage("AUTH_DATA");
        if (authData) {
            setUserData(authData.userDetail)
        }
    }, []);

    const handleUserUpdate = async () => {
        setLoading(true)
        const form = new FormData();
        const ignoreKey = ["image", "profile_image", 'password', 'otp', '__v', "user_type",
            'status', 'verified', 'createdDate'
        ]
        form.append("user_id", userData._id)
        Object.entries(userData).map(([key, value]) => {
            if (!ignoreKey.includes(key)) {
                form.append(key, value);
            }
        });
        if (profileImage !== null) {
            typeof profileImage[0] === "object" &&
                form.append("profile_image", profileImage[0]);
        }
        const headers = { "Content-Type": "application/x-www-form-urlencoded" };
        const { data } = await apiCall('post', apiEndPoint.UPDATEUSER, form, headers);
        if (data.status === 200) {
            saveToLocalStorage('AUTH_DATA', data.data)
            successMessage(data.message)
        } else {
            failedMessage(data.message)
        }
        setLoading(false)
    };
    return (
        <Fragment>
            {/* <Header /> */}
            <Container>
                <Row className="justify-content-md-center">
                    <Col xs lg="6">
                        <Card className="mt-4">
                            <CardHeader>
                                <div style={{ display: 'flex' }} className="align-items-center justify-content-between">
                                    <div lg="8">
                                        <h4>Account</h4>
                                    </div>
                                    <div lg="4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button onClick={() => navigate('/')} className="back-btn">{'<'} Back</Button>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <form>
                                    <center>
                                        <input
                                            placeholder="+ Upload your banner image"
                                            type="file"
                                            className="form-control"
                                            style={{ display: 'none' }}
                                            id="profileFile"
                                            accept="image/png, image/jpg, image/jpeg"
                                            onChange={(e) => setProfileImage(e.target.files)}
                                        />
                                        <Image
                                            src={!isEmpty(profileImage) ? URL.createObjectURL(profileImage[0]) : !isEmpty(userData?.profile_image) ? userData?.profile_image : "/assets/images/icon/user.png"}
                                            width={"80px"} style={{ height: 80 }} roundedCircle
                                        />
                                        <a className="profile-img-edit" htmlFor="exampleInputFile" onClick={() => document.getElementById('profileFile').click()} >
                                            <i class="fas fa-edit" style={{ fontSize: 12, color: '#fff' }} ></i>
                                        </a>
                                    </center>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-lg-6 mt-adj-frm">
                                                <div className="input-field-box">
                                                    <label>Name :</label>
                                                    <input
                                                        placeholder="Enter name"
                                                        type="text"
                                                        className="form-control"
                                                        value={userData?.user_name}
                                                        onChange={e => {
                                                            setUserData({
                                                                ...userData,
                                                                user_name: e.target.value,
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 mt-adj-frm">
                                                <div className="input-field-box">
                                                    <label>Contact Number :</label>
                                                    <input
                                                        placeholder="Enter number"
                                                        type="number"
                                                        className="form-control"
                                                        value={`${userData?.mobile}`}
                                                        onChange={e => {
                                                            setUserData({
                                                                ...userData,
                                                                mobile: e.target.value,
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="input-field-box">
                                                    <label>Email :</label>
                                                    <input
                                                        placeholder="Email Address"
                                                        type="email"
                                                        className="form-control"
                                                        value={userData?.email}
                                                        onChange={e => {
                                                            setUserData({
                                                                ...userData,
                                                                email: e.target.value,
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="input-field-box">
                                                    <label>Address :</label>
                                                    <textarea
                                                        placeholder="Address ..."
                                                        className="form-control"
                                                        value={userData?.address}
                                                        name='address'
                                                        onChange={e => {
                                                            setUserData({ ...userData, address: e.target.value });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <a className="forgot-link" onClick={() => { navigate('/accountsetting/changepassword') }}>Change Password</a>
                                        <center className="d-grid gap-2 mt-2">
                                            <Button onClick={() => handleUserUpdate()} className="back-btn" disabled={isLoading}>{isLoading ? <Spinner animation="border" size="sm" role="status" /> : 'Save'}</Button>
                                        </center>
                                    </div>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}

export default AccountSetting;